import { useMutation, MutationHookOptions } from '@apollo/client';

import mutation from '../../pages/Management/Fleets/updateManagedPlatformAccount.graphql';

export default function useUpdateManagedPlatformAccountMutation(
  options?: MutationHookOptions<
    UpdateManagedPlatformAccountMutation,
    UpdateManagedPlatformAccountMutationVariables
  >,
) {
  return useMutation<
    UpdateManagedPlatformAccountMutation,
    UpdateManagedPlatformAccountMutationVariables
  >(mutation, options);
}
